module.exports = __webpack_public_path__ + "static/media/bagVNActive.ee3194f6.png";